import Vue from "vue";
var eventLister = new Vue({})
export default eventLister